import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { BmcoreTracksPageComponent } from 'core'

import { BmprodBeatPageComponent } from './components/pages/bmprod-beat-page/bmprod-beat-page.component'
import { BmprodCheckoutPageComponent } from './components/pages/bmprod-checkout-page/bmprod-checkout-page.component'
import { BmprodCookiePolicyPageComponent } from './components/pages/bmprod-cookie-policy-page/bmprod-cookie-policy-page.component'
import { BmprodHomePageComponent } from './components/pages/bmprod-home-page/bmprod-home-page.component'
import { BmprodPageNotFoundComponent } from './components/pages/bmprod-page-not-found/bmprod-page-not-found.component'
import { BmprodUserAgreementPageComponent } from './components/pages/bmprod-user-agreement-page/bmprod-user-agreement-page.component'

const appRotes: Routes = [
  { path: '', component: BmprodHomePageComponent },
  { path: 'checkout', component: BmprodCheckoutPageComponent },
  { path: 'catalog', component: BmcoreTracksPageComponent },
  { path: 'catalog/:styleId', component: BmcoreTracksPageComponent },
  { path: 'catalog/:styleId/:moodId', component: BmcoreTracksPageComponent },
  { path: 'tracks/:beatId', component: BmprodBeatPageComponent },
  { path: 'user-agreement', component: BmprodUserAgreementPageComponent },
  { path: '404', component: BmprodPageNotFoundComponent },
  { path: 'cookie-policy', component: BmprodCookiePolicyPageComponent },
  { path: '**', redirectTo: '/404' }
  /* Working but unused pages*/
  // {path: 'goods', component: BmcoreGoodsPageComponent},
  // {path: 'goods/:goodId', component: BmcoreGoodItemPageComponent},
  // {path: 'services', component: BmcoreServicesPageComponent},
  // {path: 'services/:serviceId', component: BmcoreServiceItemPageComponent},
  // {path: 'technical-support', component: BmcoreTechSupportPageComponent},
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRotes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
